import { http } from '@/common/utils/HttpServices';
import { Routes } from '@/api/Routes';
import { ReglementDTO } from '@/models/ReglementDTO';
import { Operateur } from '@/models/FactureFournisseurDTO';

export interface FilterReglementFournisseur{
    page?: number;
    size?: number;
    sort?: string;
    statut?: any;
    dateDebut?: string;
    dateFin?: string;
    societeIds?: number[];
    montant?: number;
    operateur?: Operateur;
}

class ReglementService {
    public async getReglements(params: FilterReglementFournisseur): Promise<ReglementDTO[]>{
        return http.get(Routes.FactureFournisseurRoutes.RecupererReglementsFournisseur(), {params});
    }
    public async getReglementById(id: number): Promise<ReglementDTO>{
        return http.get(Routes.FactureFournisseurRoutes.RecupererReglementFournisseur(id));
    }
    public async getReglementXls(params: FilterReglementFournisseur): Promise<any>{
        return http.get(Routes.FactureFournisseurRoutes.RecupererReglementsFournisseurXls(), {params, responseType: 'arraybuffer' });
    }
}

export default new ReglementService();
